import { fromJS } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import { selectResultOfAlertType } from './AlertItemConstants';

export const initialState = fromJS({});

export const spec = {
  [selectResultOfAlertType]: (state, action) => {
    const { alertId, runId } = action.payload;

    return state.setIn([alertId, 'currentRunId'], runId);
  },
};

const alertItemReducer = createReducerBySpec(spec, initialState);

export default alertItemReducer;
